/*
 * Copyright (c) 2021 LNBIG.com
 * All rights reserved.
 */

export default {
    computed: {
        sizeQrCode () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                case 'sm':
                    return 200
                default:
                    return 300
            }
        },
        levelQrCode() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                case 'sm':
                    return 'H'
                default:
                    return 'Q'
            }
        }
    }
}
